import { mapGetters } from "vuex";
import { UUID, trimLayout } from "@/components/widgets/helpers";

export default {
  data() {
    return {
      // TODO: These need to come from interests widget
      dragging: false,
      editMode: false,
      currentLayout: null,
      activeLayout: null,
      activeRow: null,
      activeColumn: null,
      activeWidget: null,
      activeWidgetType: null,
      showColumnWidthModal: false,
      showWidgetModal: false,
      showConfigureWidget: false,
      newProps: [],
      mainLayout: [],
      headerLayout: [],
      footerLayout: [],
      configSubmitted: false,
      validationFailed: false
    };
  },
  computed: {
    name() {
      return this.data;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    noElements() {
      return (
        this.headerLayout.length +
          this.mainLayout.length +
          this.footerLayout.length <=
        0
      );
    },
  },
  methods: {
    async toggleCustomize() {
      this.editMode = !this.editMode;

      if (!this.editMode) {
        // if we are cancelling the edit, just reload the current state and re-set the widgets
        this.loading = true;
        await this.$store.dispatch("widgets/getUserDashboard");
        this.headerLayout = this.$store.getters["widgets/mergedHeaderWidgets"];
        this.mainLayout = this.$store.getters["widgets/mergedMainWidgets"];
        this.footerLayout = this.$store.getters["widgets/mergedFooterWidgets"];
        this.loading = false;
      }

      if (!this.editMode) {
        // if we are cancelling, revert back to original state
        this.$store.dispatch("widgets/resetDashboard");
      }
    },
    deleteRow(index, layout = "currentLayout") {
      this[layout].splice(index, 1);
    },
    hasNoAdminElements(index, layout = "currentLayout") {
      const row = this[layout][index];

      const adminTotal = row.filter((el) => el.admin);

      return adminTotal.length < 1;
    },
    notSingleCol(index, layout) {
      const row = this[layout][index];

      if (!row) {
        return true;
      }

      return row.length > 1;
    },

    deleteElement(row, item, layout = "currentLayout") {
      this[layout][row][item].type = "";
      this[layout][row][item].uuid = "";
    },
    saveLayout() {
      const { headerLayout, mainLayout, footerLayout } = this;
      this.$store
        .dispatch("widgets/setUserDashboard", {
          layouts: {
            headerLayout,
            mainLayout,
            footerLayout,
          },
          admin: false,
        })
        .then((resp) => {
          // TODO: Should we reload?  Layout should be cleared from cache either way
          this.loading = true;
          this.$store.dispatch("widgets/reloadDashboard").then(() => {
            // need to trim empty rows
            this.headerLayout = trimLayout(this.headerLayout);
            this.mainLayout = trimLayout(this.mainLayout);
            this.footerLayout = trimLayout(this.footerLayout);
            this.editMode = false;
            this.loading = false;
            this.$store.dispatch(
              "notifications/create",
              {
                body: `Your layout was updated successfully`,
                type: "success",
              },
              { root: true }
            );
          });
        });
    },
    toggleColumnWidth(index, layout = "currentLayout") {
      this.showColumnWidthModal = !this.showColumnWidthModal;
      this.activeLayout = this.showColumnWidthModal ? layout : null;
      this.activeRow = this.showColumnWidthModal ? index : null;
    },
    toggleAddWidget(row, column, layout = "currentLayout") {
      this.showWidgetModal = !this.showWidgetModal;
      this.activeRow = this.showWidgetModal ? row : null;
      this.activeLayout = this.showWidgetModal ? layout : null;
      this.activeColumn = this.showWidgetModal ? column : null;
    },
    setColumnCount(count) {
      const activeRow = JSON.parse(
        JSON.stringify(this[this.activeLayout][this.activeRow])
      );
      const currentRowLength = activeRow.length;

      let newRow;
      let cssClass;

      if (currentRowLength < count) {
        cssClass = 12 / count;
        // if we are adding columns, we need to alter the current rows size and add a new one
        newRow = activeRow.map((row) => {
          return {
            ...row,
            cssClass,
          };
        });
        const diff = count - currentRowLength;

        for (let i = 0; i < diff; i++) {
          newRow.push({
            type: "",
            cssClass,
            uuid: UUID.generate(),
          });
        }
        this[this.activeLayout].splice(this.activeRow, 1, newRow);
        this.toggleColumnWidth(this.activeRow);
      } else if (currentRowLength > count) {
        // here we want to remove columns?
        // confirm to the user first
        this.$store.dispatch("createDialog", {
          messageText:
            "If you reduce the number of columns in a row, you may lose any widgets and configurations you have made.",
          confirm: () => {
            const diff = currentRowLength - count;

            this[this.activeLayout][this.activeRow].splice(`-${diff}`);

            cssClass = 12 / count;
            // if we are adding columns, we need to alter the current rows size and add a new one
            newRow = this[this.activeLayout][this.activeRow].map((row) => {
              return {
                ...row,
                cssClass,
              };
            });
            this[this.activeLayout].splice(this.activeRow, 1, newRow);
            this.toggleColumnWidth(this.activeRow);
          },
        });
      } else {
        this.toggleColumnWidth(this.activeRow);
      }
    },
    addWidget(widget) {
      const column = this[this.activeLayout][this.activeRow][this.activeColumn];
      column.type = `${widget}-widget`;

      // get props from widget state
      const props = this.$store.getters[`widgets/${widget}/getProps`];
      column.props = {};

      props.forEach((prop) => {
        column.props[prop.key] = prop.value;
      });

      // when adding a widget, we need to generate a new uuid regardless
      column.uuid = UUID.generate();

      // also need to get the props from the type

      this.toggleAddWidget(
        this.activeRow,
        this.activeColumn,
        this.activeLayout
      );
    },
    addRow(layout = "currentLayout") {
      this[layout].push([
        {
          type: "",
          cssClass: 12,
          uuid: UUID.generate(),
        },
      ]);
      this.toggleColumnWidth(this[layout].length - 1, layout);
    },

    getIcon(mod) {
      return this.$store.getters[`widgets/${mod}/getIcon`];
    },

    togglePreference(row, column, layout = "currentLayout") {
      this.showConfigureWidget = !this.showConfigureWidget;
      this.activeRow = this.showConfigureWidget ? row : null;
      this.activeLayout = this.showConfigureWidget ? layout : null;
      this.activeColumn = this.showConfigureWidget ? column : null;
      if (
        this.activeRow !== null &&
        this.activeColumn !== null &&
        this.activeLayout !== null
      ) {
        this.activeWidget = this[this.activeLayout][this.activeRow][
          this.activeColumn
        ];
        this.activeWidgetType = this.activeWidget.type.split("-")[0];
        this.activeWidget.propsConfig = this.$store.getters[
          `widgets/${this.activeWidgetType}/getProps`
        ];
        this.newProps = JSON.parse(JSON.stringify(this.activeWidget.props));
      }
    },
    updateContentType(label, type) {
      if (this.newProps[label].includes(type)) {
        if (typeof this.newProps[label] === "object") {
          const index = this.newProps[label].indexOf(type);
          this.newProps[label].splice(index, 1);
        } else {
          this.newProps[label] = type;
        }
      } else {
        if (typeof this.newProps[label] === "object") {
          this.newProps[label].push(type);
        } else {
          this.newProps[label] = type;
        }
      }
    },
    async saveProp() {
      this.configSubmitted = true;
      this.validationFailed = false;
      const vm = this;

      this.$validator.validate().then((result) => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          this.activeWidget.props = this.newProps;
          this.togglePreference(this.activeRow, this.activeColumn);
          this.newProps = null;
          // then reload the dashboard?
          this.$store.dispatch("widgets/reloadDashboard");
        }
      });
    },

    hasPropOptions(type, label) {
      return (
        (this.$store.state.widgets[type].propOptions &&
          this.$store.state.widgets[type].propOptions[label]) ||
        false
      );
    },

    getPropOptions(type, label) {
      let toReturn = [];
      if (this.$store.state.widgets[type].propOptions[label].options) {
        toReturn = this.$store.state.widgets[type].propOptions[label].options;
      }
      return toReturn;
    },
    isMultiple(type, label) {
      return (
        this.$store.state.widgets[type].propOptions[label].multiple || false
      );
    },
  },
};
